//import { AxiosRequestConfig } from "axios";
import axios, { AxiosRequestConfig } from "axios";
import { instance } from "./axios";
import { v4 as uuid } from "uuid";
import { CONST_CONF, CONST_LABELS, CONST_TERMS } from "../../app/pages/Commons";
import { ResponseModel } from "../../app/models/ResponseModel";


// axios.interceptors.request.use(function (urlStr) {

//   urlStr = "http://localhost:8090" + urlStr
//   return urlStr;
// }, function (error) {
//   // Do something with request error
//   return Promise.reject(error);
// });

export function tdSendHttpPostReq<Model>(urlStr: string, bodyJson: any, reqId: string, resourceKey: string): Model {
  var custInfoRes: Array<string> = [];

  // if(CONST_CONF.get("IS_PROD")=="1")
  // urlStr= "https://app.tangerine-digital.com" + urlStr; //TODO: Uncomment when live
  // urlStr= "http://localhost:8090" + urlStr;
  let data1: Model = <Model>"null";
  var tokenStr: string = "RFROVDU0cml1SGpsSmQwOVBPbGpXaXlhcHBMdEdrOnRuenNkbGZ0czBvcGw2cnM=";
  // var tokenstr = window.btoa(CONST_CONF.get("AFF_USR")+":"+CONST_CONF.get("AFF_PWD")); //TODO: Uncomment when live
  const headers = { "Content-Type": "application/json", "Authorization": "Basic " + tokenStr, "correlatorId": reqId, "ResourceKey": resourceKey };
  console.log("Calling API : " + urlStr);

  // const config = {headers: headers, data: bodyJson}
  const config = { url: urlStr, method: "POST", headers: headers, data: bodyJson };
  // var tokenR = await fetch(urlStr, { method: 'POST', headers, body: bodyJson});
  // var tokenR = await axios.post(urlStr, [bodyJson], { headers: headers});

  // var tokenR = await axios.request<ResponseModel>(config)

   let resp  =  axios.request(config);//.then(function(axiosResponse));

  /* {
    console.log("axiosResponse.data",axiosResponse.data)
    data1 = <Model>axiosResponse.data;

    console.log("data",data1)
    return data1;


  }).catch(function (error) {
    data1 = <Model>error.response.data;
   })*/

  setTimeout(() => console.log("dataaa",data1), 0);
  // const { data } = await tokenR
  console.log("Data:",data1)
  return data1;


}

// TODO Should use the token in the userData context
export const httpGet = async (
  requestPath: string,
  config?: AxiosRequestConfig
): Promise<any> => {
  const axiosResponse = await instance.get(requestPath, {
    // headers: {
    //   crossdomain: true,
    //   // "Access-Control-Allow-Origin": "*",
    // },
    // proxy: {
    //   host: "104.236.174.88",
    //   port: 3128,
    // },
    ...config
  });
  return axiosResponse.data;
};
export const httpGetWithAuth = async (
  requestPath: string,
  config?: AxiosRequestConfig,
  userToken?: string
): Promise<any> => {
  const axiosResponse = await instance.get(requestPath, {
    headers: {
      Authorization: "Bearer " + userToken
    },
    ...config
  });
  return axiosResponse.data;
};
export const httpPost = async (
  requestPath: string,
  data: any,
  config?: AxiosRequestConfig,
  userToken?: string
): Promise<any> => {
  const axiosResponse = await instance.post(requestPath, data, {
    headers: {
      Authorization: "Bearer " + userToken
    },
    ...config
  });
  return axiosResponse.data;
};

export const httpPut = async (
  requestPath: string,
  data: any,
  config?: AxiosRequestConfig
): Promise<any> => {
  const axiosResponse = await instance.put(requestPath, data, {
    headers: {
      Authorization: "Bearer null"
    },
    ...config
  });
  return axiosResponse.data;
};

export const httpDelete = async (
  requestPath: string,
  config?: AxiosRequestConfig
): Promise<any> => {
  const axiosResponse = await instance.delete(requestPath, {
    headers: {
      Authorization: "Bearer null"
    },
    ...config
  });
  return axiosResponse.data;
};
